import styled from 'styled-components';

export const HistoryText = styled.div`
  flex: 1;
  min-width: 0;
  margin: 14px 0;
  font-size: 14px;
`;
